/**
 * ROC 7
 * Copyright 2016 ROC Commerce
 * 
 * Any modifications required of core files should be handled in supplemental files 
 * or duplicates of said core files. This is to assist in upgrade paths.
 */


// # User Product Price related scripts

define('modules/Product/ProductPrice',[
    'jquery',
    'global/all',
    'plugins/accounting.min',
    'modules/Product/CachedPrice',
], function ($, Roc, accounting, cachedPrice) {
    'use strict';

    function reloadProductPrice(viewModel) {
        // always update cached items to avoid stale cache
        cachedPrice.updateCachedPricing(viewModel.id, viewModel.productPricing);
        if (viewModel.productPricing && viewModel.productPricing.userUnitPrice > 0 && viewModel.productPricing.availableQty && viewModel.productPricing.availableQty > 0) {
            viewModel.productPricing.showAvailability = true;
        }
        else {
            viewModel.productPricing.showAvailability = false;
        }
        Roc.UI.template('productPricingDetails-Tmp', viewModel.productPricing).then(function (renderedTemplate) {
            $('[data-roc-binding="pricing"]').html(renderedTemplate);
        });

        //TODO: KITS
        if (viewModel.productType === 'Simple') {
            $('[data-roc-binding="itemCheckoutBox"]').show();
            if (viewModel.customFields.customerPartNumber) {
                $('.title-part-number').html('Part#: <span itemprop="sku">' +
                    viewModel.customFields.customerPartNumber[0].value +
                    '</span>');
            } else {
                $('.title-part-number').html('Part#: <span itemprop="sku">' + viewModel.sku + '</span>');
            }

            if (viewModel.shortDescription) {
                $('.itemDesc').html('<div class="item-detail-short-desc">' + viewModel.shortDescription + '</div>');
            } else {
                $('.itemDesc').empty();
            }
        } else {
            $('.title-part-number').empty();
            $('[data-roc-binding="itemCheckoutBox"]').hide();
        }

        var $QuoteBtn = $('#QuoteBtn[href*=\'ProductId\']');
        if ($QuoteBtn.length > 0) {
            var href = $QuoteBtn.attr('href');
            $QuoteBtn.attr('href', href.substring(0, href.indexOf('=') + 1) + viewModel.id);
        }
    }

    function getPricingBasedOnQty() {
        var currentQty = parseInt($('#purchaseQuantity').val());
        if (isNaN(currentQty) || currentQty <= 0) {
            currentQty = 1;
        }
        var currentProductId = $("#hdnProductId").val();
        return cachedPrice.getQuantityDiscountedPricing(currentProductId, currentQty);
    }

    function displayTotalPrice(pricing) {
        var currentQty = parseInt($('#purchaseQuantity').val());
        var totalPrice = pricing.userUnitPrice * currentQty;
        $("#totalPrice").html("<span>Total Price: " + accounting.formatMoney(totalPrice) + "</span><br />");
    }

    function bindQuantityChangedEvent() {
        Roc.UI.siteBody
            .off('change', '#purchaseQuantity')
            .on('change', '#purchaseQuantity', function (e) {
                var pricing = getPricingBasedOnQty();
                if (pricing && pricing.userUnitPrice > 0) {
                    $('[data-roc-binding="pricing"] [itemprop="price"]').html(accounting.formatMoney(pricing.userUnitPrice));
                    displayTotalPrice(pricing);
                }
            });
    }

    function bindEvents() {
        Roc.EventManager.bind(Roc.Events.products.SELECTIONS_UPDATE, reloadProductPrice);
        bindQuantityChangedEvent();
    }

    function init(productId, productPricing) {
        cachedPrice.initForDetailsPage(productId, productPricing);
        bindEvents();
    }

    var ProductPrice = {
        init: init
    };

    Roc.Logger.debug('ProductPrice.js Loaded:', ProductPrice);

    return ProductPrice;
});
